/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchBillOrderReqVo } from './BatchBillOrderReqVo';
import {
    BatchBillOrderReqVoFromJSON,
    BatchBillOrderReqVoFromJSONTyped,
    BatchBillOrderReqVoToJSON,
    BatchBillOrderReqVoToJSONTyped,
} from './BatchBillOrderReqVo';
import type { CancelGoodsItem } from './CancelGoodsItem';
import {
    CancelGoodsItemFromJSON,
    CancelGoodsItemFromJSONTyped,
    CancelGoodsItemToJSON,
    CancelGoodsItemToJSONTyped,
} from './CancelGoodsItem';

/**
 * 
 * @export
 * @interface BatchBillCreateReqVo
 */
export interface BatchBillCreateReqVo {
    /**
     * 账单类型
     * @type {number}
     * @memberof BatchBillCreateReqVo
     */
    billType: number;
    /**
     * 汇率（非必填，不传则自动获取）
     * @type {number}
     * @memberof BatchBillCreateReqVo
     */
    exchangeRate?: number;
    /**
     * 货币代码
     * @type {string}
     * @memberof BatchBillCreateReqVo
     */
    currencyCode: string;
    /**
     * 账单状态：0-未支付，1-待汇款，2-已支付，3-已取消
     * @type {number}
     * @memberof BatchBillCreateReqVo
     */
    status: number;
    /**
     * 钱包转账总金额，默认为0
     * @type {number}
     * @memberof BatchBillCreateReqVo
     */
    totalTransferAmount?: number;
    /**
     * 卡号
     * @type {string}
     * @memberof BatchBillCreateReqVo
     */
    cardNumber?: string;
    /**
     * 卡类型：1-储蓄卡，2-信用卡
     * @type {number}
     * @memberof BatchBillCreateReqVo
     */
    cardType?: number;
    /**
     * 卡所在银行名称
     * @type {string}
     * @memberof BatchBillCreateReqVo
     */
    cardBankName?: string;
    /**
     * 持卡人姓名
     * @type {string}
     * @memberof BatchBillCreateReqVo
     */
    cardHolderName?: string;
    /**
     * 备注
     * @type {string}
     * @memberof BatchBillCreateReqVo
     */
    remark?: string;
    /**
     * 创建账单的管理员ID，只有管理员主动给用户创建账单时才有值
     * @type {number}
     * @memberof BatchBillCreateReqVo
     */
    createStaffId?: number;
    /**
     * 是否发送短信：1-发送，0-不发送
     * @type {number}
     * @memberof BatchBillCreateReqVo
     */
    sendSms?: number;
    /**
     * 明细通用内容（JSON字符串）
     * @type {string}
     * @memberof BatchBillCreateReqVo
     */
    detailContent?: string;
    /**
     * 账单关联实体ID（按账单类型不同区分，如无数据商品编号）
     * @type {number}
     * @memberof BatchBillCreateReqVo
     */
    targetId?: number;
    /**
     * 仓库ID（非必填，订单创建账单时传订单current_warehouse_id；钱包操作类账单不传）
     * @type {number}
     * @memberof BatchBillCreateReqVo
     */
    warehouseId?: number;
    /**
     * 退款金额（未传时默认为0）
     * @type {number}
     * @memberof BatchBillCreateReqVo
     */
    returnAmount?: number;
    /**
     * 钱包支付金额（仅billType=4或20时使用）
     * @type {number}
     * @memberof BatchBillCreateReqVo
     */
    walletPay?: number;
    /**
     * 卡支付金额（仅billType=4或20时使用）
     * @type {number}
     * @memberof BatchBillCreateReqVo
     */
    cardPay?: number;
    /**
     * 代买取消商品列表（仅billType=2代买取消手续费时使用，部分取消时传入）
     * @type {Array<CancelGoodsItem>}
     * @memberof BatchBillCreateReqVo
     */
    cancelGoodsList?: Array<CancelGoodsItem>;
    /**
     * 订单列表（每个订单单独传差异字段）
     * @type {Array<BatchBillOrderReqVo>}
     * @memberof BatchBillCreateReqVo
     */
    orders: Array<BatchBillOrderReqVo>;
}

/**
 * Check if a given object implements the BatchBillCreateReqVo interface.
 */
export function instanceOfBatchBillCreateReqVo(value: object): value is BatchBillCreateReqVo {
    if (!('billType' in value) || value['billType'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('orders' in value) || value['orders'] === undefined) return false;
    return true;
}

export function BatchBillCreateReqVoFromJSON(json: any): BatchBillCreateReqVo {
    return BatchBillCreateReqVoFromJSONTyped(json, false);
}

export function BatchBillCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchBillCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'billType': json['billType'],
        'exchangeRate': json['exchangeRate'] == null ? undefined : json['exchangeRate'],
        'currencyCode': json['currencyCode'],
        'status': json['status'],
        'totalTransferAmount': json['totalTransferAmount'] == null ? undefined : json['totalTransferAmount'],
        'cardNumber': json['cardNumber'] == null ? undefined : json['cardNumber'],
        'cardType': json['cardType'] == null ? undefined : json['cardType'],
        'cardBankName': json['cardBankName'] == null ? undefined : json['cardBankName'],
        'cardHolderName': json['cardHolderName'] == null ? undefined : json['cardHolderName'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'createStaffId': json['createStaffId'] == null ? undefined : json['createStaffId'],
        'sendSms': json['sendSms'] == null ? undefined : json['sendSms'],
        'detailContent': json['detailContent'] == null ? undefined : json['detailContent'],
        'targetId': json['targetId'] == null ? undefined : json['targetId'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'returnAmount': json['returnAmount'] == null ? undefined : json['returnAmount'],
        'walletPay': json['walletPay'] == null ? undefined : json['walletPay'],
        'cardPay': json['cardPay'] == null ? undefined : json['cardPay'],
        'cancelGoodsList': json['cancelGoodsList'] == null ? undefined : ((json['cancelGoodsList'] as Array<any>).map(CancelGoodsItemFromJSON)),
        'orders': ((json['orders'] as Array<any>).map(BatchBillOrderReqVoFromJSON)),
    };
}

export function BatchBillCreateReqVoToJSON(json: any): BatchBillCreateReqVo {
    return BatchBillCreateReqVoToJSONTyped(json, false);
}

export function BatchBillCreateReqVoToJSONTyped(value?: BatchBillCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billType': value['billType'],
        'exchangeRate': value['exchangeRate'],
        'currencyCode': value['currencyCode'],
        'status': value['status'],
        'totalTransferAmount': value['totalTransferAmount'],
        'cardNumber': value['cardNumber'],
        'cardType': value['cardType'],
        'cardBankName': value['cardBankName'],
        'cardHolderName': value['cardHolderName'],
        'remark': value['remark'],
        'createStaffId': value['createStaffId'],
        'sendSms': value['sendSms'],
        'detailContent': value['detailContent'],
        'targetId': value['targetId'],
        'warehouseId': value['warehouseId'],
        'returnAmount': value['returnAmount'],
        'walletPay': value['walletPay'],
        'cardPay': value['cardPay'],
        'cancelGoodsList': value['cancelGoodsList'] == null ? undefined : ((value['cancelGoodsList'] as Array<any>).map(CancelGoodsItemToJSON)),
        'orders': ((value['orders'] as Array<any>).map(BatchBillOrderReqVoToJSON)),
    };
}

